var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.createOnamaeSession}},[_vm._v("\n  最新の会員情報を同期する\n")])}
var staticRenderFns = []

export { render, staticRenderFns }